import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useRecoilState, useRecoilValue } from 'recoil'
import styled from '@emotion/styled'
import { Close } from '@emotion-icons/material/Close'
import { IconButton } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { Modal } from 'src/components/modal'
import { ErrorBoundary } from 'src/components/errors/error-boundary'
import { PaymentsLoading } from 'src/views/subscriptions/loading'
import { PaymentPlans } from 'src/views/subscriptions/create/payment-plans'
import { SelectedPlan } from 'src/views/subscriptions/create/selected-plan'
import { Confirmation } from 'src/views/subscriptions/create/confirmation'
import { SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS, SUBSCRIPTION_MODAL_DIMENSIONS } from 'src/constants/subscriptions'
import { Steps } from 'src/components/steps'
import { useCloseAndResetSubscriptionModal } from 'src/views/subscriptions/hooks'

import * as paymentsAtoms from 'src/atoms/payments'

const stepComponents = [<PaymentPlans />, <SelectedPlan />, <Confirmation />]

const ModalContent = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${Shapes.spacing[6]}px;
`
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${Shapes.spacing[6]}px;
  width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  max-width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  margin: 0 auto;
  & > div {
    flex: 1;
  }
`
const Body = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`

export const CreateSubscription = () => {
  const [subscribeModalOpen, setSubscribeModalOpen] = useRecoilState(paymentsAtoms.subcribeModalOpen)
  const activeStep = useRecoilValue(paymentsAtoms.subscriptionUpdateStep)
  const pathname = usePathname()

  const closeAndResetSubscriptionModal = useCloseAndResetSubscriptionModal()

  const onClose = async () => {
    closeAndResetSubscriptionModal()
  }

  useEffect(() => {
    if (subscribeModalOpen) {
      return
    }
    if (pathname.includes('upgrade')) {
      setSubscribeModalOpen(true)
      return
    }
  }, [pathname, subscribeModalOpen])

  return (
    <Modal
      open={subscribeModalOpen}
      style={{
        height: `${SUBSCRIPTION_MODAL_DIMENSIONS.height}px`,
        width: `100%`,
        maxWidth: `${SUBSCRIPTION_MODAL_DIMENSIONS.width}px`,
      }}>
      <ModalContent>
        <Header>
          <IconButton
            style={{
              position: `absolute`,
              top: `${Shapes.spacing[5]}px`,
              right: `${Shapes.spacing[5]}px`,
            }}
            onClick={onClose}>
            <Close size={24} color={Colors.textDark} />
          </IconButton>
          <Steps activeStep={activeStep} steps={['Choose Plan', 'Confirm Plan', 'Confirmation']} />
        </Header>
        <Body>
          <ErrorBoundary>
            <React.Suspense fallback={<PaymentsLoading />}>{stepComponents[activeStep]}</React.Suspense>
          </ErrorBoundary>
        </Body>
      </ModalContent>
    </Modal>
  )
}
